import { gql } from '@apollo/client';
import {
  coupledLineItemsOnInvoice,
  lineItemDetailsForInvoice,
} from '../../../../account-subscriptions/billing-v2/invoices/src/queries/fetch-coupled-line-items';

export const fetchInvoiceForSidebarQuery = gql`
  ${lineItemDetailsForInvoice}
  ${coupledLineItemsOnInvoice}
  query fetchInvoiceForSidebarQuery($id: ID!, $fetchAddOns: Boolean = false, $fetchAGPAddon: Boolean = false) {
    invoice(id: $id, fetchAddOns: $fetchAddOns, fetchAGPAddon: $fetchAGPAddon) {
      id
      invoiceNumber
      sourceId
      selfServeBACInvoiceLink
      invoiceNumber
      domain
      status
      createdTimestamp
      billingGroupId
      creditCard {
        last4Numbers
        cardHolderName
        expirationMonth
        expirationYear
        brand
      }
      dunningStatus {
        attemptCount
        paymentRetryDate
        errorCode
        declineCode
        nextPaymentAttempDate
      }
      sourceSystem
      upgradeCredits
      totalDiscount
      memo
      billTo {
        fullName
        organization
        email
        address {
          address1
          address2
          city
          country
          phone
          postalCode
          state
        }
        taxId
        taxIds {
          id
          label
        }
        taxLabels {
          region
          taxIdLabels {
            description
            displayName
            type
          }
        }
      }
      shipTo {
        fullName
        organization
        email
        address {
          address1
          address2
          city
          country
          phone
          postalCode
          state
        }
        taxId
        taxIds {
          id
          label
        }
        taxLabels {
          region
          taxIdLabels {
            description
            displayName
            type
          }
        }
      }
      total
      taxes
      subtotal
      taxes
      taxesPaymentCurrency
      transactionAccountId
      itemsTotal
      partnerAccountId
      partnerName
      paypalAccountEmail
      paymentCurrency
      paymentMethod
      promotionCode
      invoiceDueDays
      dueDate
      purchaseOrderNumber
      lineItems {
        ...lineItemDetailsForInvoice
      }
      coupledLineItems(fetchAGPAddon: $fetchAGPAddon) {
        ...coupledLineItemsOnInvoice
      }
      dstLineItems {
        ...lineItemDetailsForInvoice
        metadata {
          parentItemId
          type
        }
      }
      refunds {
        id
        creditNoteNumber
        currency
        createdDate
        transactionAccountId
        sourceSystem
        memo
        reason
        refundId
        status
        type
        total
        arn
        refundItems {
          id
          invoiceLineItemId
          entitlementId
          quantity
          description
          total
          totalExTax
          totalTax
          taxRate
          taxableAmount
          taxExemptAmount
        }
        requestedBy
      }
      slaCredits {
        amountExTax
        amountIncTax
        createdAt
        creditExternalId
        currency
        currencyExchangeRate
        modifiedAt
        notes
        taxAmount
        taxRate
      }
      pdfLink
      appliedBalance
    }
  }
`;
